define('rebrush/components/ui/tooltips',[
	"jquery",
	"cartware/components/_base",
	"bootstrap-tooltip"
], function(
	$,
	Component
) {
	return Component.create({
		$init: function() {
			$(document.body).on("mouseover", '[data-toggle="tooltip"]', function(e) {
				var $this   = $(this),
					data    = $this.data('bs.tooltip');

				if (!data) {
					$this.tooltip({
						html: true,
						container: 'body'
					});
				}

				$this.tooltip("show");
			});
		}
	});
});
